import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { navActionCreators } from "../../stores/lis-nav-store";
import { Link } from "react-router-dom";
import renderHTML from 'react-render-html';
import { collectionActionCreators } from "../../stores/lis-collection-store";
import moment from "moment-timezone";
import { sessionActionCreators } from "../../stores/lis-session-store";
import { authActionCreators } from "../../stores/lis-auth-store";
import { sortLegislations, LinkAsButton } from "../../services/legislation-helper-service";
import DeleteWatchlistModal from '../components/lis-public-delete-watchlist-modal';

class WatchlistsComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sessionOptions: [],
            watchlists: [],
            filterValue: "",
            nameSort: true,
            descSort: undefined,
            dateSort: undefined,
            billNumberSort: false,
            viewCrossReferenceList: false,
            expandedWatchlists: [],
            legislationList: [],
            expandedBills: [],
            filteredBills: [],
            filteredBillsValue: "",
            expandAllWatchlists: false,
            expandAllBills: false,
            loadingCollections: true,
            showPopup: false
        }

        this.getWatchlists = this.getWatchlists.bind(this);
        this.sortByName = this.sortByName.bind(this);
        this.sortByDesc = this.sortByDesc.bind(this);
        this.sortByDate = this.sortByDate.bind(this);
        this.toggleBillList = this.toggleBillList.bind(this);
        this.toggleCrossReferenceList = this.toggleCrossReferenceList.bind(this);
        this.toggleWatchlistList = this.toggleWatchlistList.bind(this);
        this.toggleWatchlist = this.toggleWatchlist.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
        this.deleteWatchlists = this.deleteWatchlists.bind(this);
        this.updateCrossReferenceList = this.updateCrossReferenceList.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.printRef = React.createRef();
    }

    componentDidMount() {
        if (!this.props.session.sessionList || !this.props.session.sessionList.length) {
            this.props.actions.getSessionList()
                .then(() => {
                    this.setState({
                        sessionOptions: this.props.session.sessionList
                    }, () => {
                        this.getWatchlists();
                    })
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                });
        } else {
            this.setState({
                sessionOptions: this.props.session.sessionList
            }, () => {
                this.getWatchlists();
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.nav.session != this.props.nav.session || prevProps.login.isAuthenticated != this.props.login.isAuthenticated) {
            this.setState({ loadingCollections: true }, () => {
                this.getWatchlists();
            })
        }
    }

    getWatchlists() {
        if (this.props.nav.session) {
            const selectedSession = this.state.sessionOptions.find(s => s.SessionCode === this.props.nav.session);
            if (selectedSession) {
                if (this.props.login.isAuthenticated) {
                    this.props.actions.getCollections("?SessionID=" + selectedSession.SessionID)
                        .then(() => {
                            this.setState({
                                watchlists: this.props.collection.collections,
                                filterValue: ""
                            }, () => {
                                this.updateCrossReferenceList();
                            });
                        });
                } else {
                    this.setState({
                        loadingCollections: false,
                    });
                }
            }
        }
    }

    updateCrossReferenceList() {
        let legislationList = [];
        for (let i = 0; i < this.state.watchlists.filter(w => !w.DeletionDate).length; i++) {
            for (let j = 0; j < this.state.watchlists.filter(w => !w.DeletionDate)[i].WatchListLegislation.length; j++) {
                let legislationIndex = legislationList.findIndex(x => x.LegislationNumber === this.state.watchlists.filter(w => !w.DeletionDate)[i].WatchListLegislation[j].LegislationNumber);
                if (legislationIndex >= 0) {
                    legislationList[legislationIndex].watchlists.push(this.state.watchlists.filter(w => !w.DeletionDate)[i]);
                } else {
                    let newLegislation = JSON.parse(JSON.stringify(this.state.watchlists.filter(w => !w.DeletionDate)[i].WatchListLegislation[j]));
                    newLegislation.watchlists = [this.state.watchlists.filter(w => !w.DeletionDate)[i]];
                    legislationList.push(newLegislation);
                }
            }
        }

        this.setState({
            legislationList: legislationList,
            loadingCollections: false
        })
    }

    sortByName() {
        this.setState({
            watchlists: this.state.watchlists.toSorted((a, b) => !this.state.nameSort ? a.Name?.localeCompare(b.Name) : b.Name?.localeCompare(a.Name)),
            nameSort: !this.state.nameSort,
            descSort: undefined,
            dateSort: undefined
        })
    }

    sortByDesc() {
        // Have to do nullish coalescence, otherwise it just kinda ... breaks
        this.setState({
            watchlists: this.state.watchlists.toSorted((a, b) => !this.state.descSort ? a.Description?.localeCompare(b.Description ?? '') ?? -1 : b.Description?.localeCompare(a.Description ?? '') ?? -1),
            descSort: !this.state.descSort,
            nameSort: undefined,
            dateSort: undefined
        })
    }

    sortByDate() {
        this.setState({
            watchlists: this.state.watchlists.toSorted((a, b) => moment(a.ModificationDate).tz('America/New_York').isBefore(moment(b.ModificationDate).tz('America/New_York')) ? this.state.dateSort ? -1 : 1 : this.state.dateSort ? 1 : -1),
            dateSort: !this.state.dateSort,
            nameSort: undefined,
            descSort: undefined
        })
    }

    toggleBillList(watchListIDsParam, toggleAll) {
        let watchListIDs;

        if (!Array.isArray(watchListIDsParam)) {
            watchListIDs = [watchListIDsParam];
        } else {
            watchListIDs = watchListIDsParam;
        }

        let expandedWatchlists = [...this.state.expandedWatchlists];

        for (let i = 0; i < watchListIDs.length; i++) {
            if (!expandedWatchlists.find(x => x.WatchListID === watchListIDs[i])) {
                let watchlist = this.state.watchlists.find(x => x && x.WatchListID === watchListIDs[i]);
                watchlist.expanded = true;
                expandedWatchlists.push(watchlist);
            } else {
                expandedWatchlists.find(x => x.WatchListID === watchListIDs[i]).expanded = toggleAll !== undefined ? toggleAll : !expandedWatchlists.find(x => x.WatchListID === watchListIDs[i]).expanded;
            }
        }

        this.setState({
            expandedWatchlists: expandedWatchlists
        })
    }

    toggleCrossReferenceList() {
        this.setState({
            viewCrossReferenceList: !this.state.viewCrossReferenceList
        })
    }

    toggleWatchlist(WatchListID) {
        let watchlists = this.state.watchlists.map(w => ({
            ...w,
            checked: w.WatchListID === WatchListID ? !w.checked : w.checked
        }))
        this.setState({ watchlists })
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    deleteWatchlists() {
        let watchlists = [...this.state.watchlists];
        let watchlistsToDelete = watchlists.filter(w => w.checked);
        if (watchlistsToDelete.length) {
            this.setState({ deletingWatchlists: true }, () => {
                watchlistsToDelete.forEach(wl => wl.DeletionDate = moment());
                this.props.actions.saveCollections({ WatchLists: watchlistsToDelete })
                    .then(() => {
                        watchlists = watchlists.filter(wl => !wl.checked && !wl.DeletionDate);
                        if (this.state.sortByDate) {
                            watchlists.sort((a, b) => moment(a.ModificationDate).tz('America/New_York').isBefore(moment(b.ModificationDate).tz('America/New_York')) ? this.state.dateSort ? -1 : 1 : this.state.dateSort ? 1 : -1);
                        } else if (this.state.sortByName) {
                            watchlists.sort((a, b) => !this.state.nameSort ? a.Name?.localeCompare(b.Name) : b.Name?.localeCompare(a.Name));
                        } else if (this.state.sortByDesc) {
                            watchlists.sort((a, b) => !this.state.descSort ? a.Description?.localeCompare(b.Description ?? '') ?? -1 : b.Description?.localeCompare(a.Description ?? '') ?? -1);
                        }
                        this.props.actions.makeToast([{ message: "Delete Successful", type: "success" }]);
                        this.setState({
                            watchlists,
                            deletingWatchlists: false,
                        }, () => {
                            this.togglePopup();
                            this.updateCrossReferenceList();
                        });
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        this.setState({
                            deletingWatchlists: false
                        });
                        this.props.actions.makeToast([{ message: "Delete Failed", type: "failure" }]);
                    });
            })
        }
    }

    toggleWatchlistList(legislationNumbersParam, toggleAll) {
        let legislationNumbers;

        if (!Array.isArray(legislationNumbersParam)) {
            legislationNumbers = [legislationNumbersParam];
        } else {
            legislationNumbers = legislationNumbersParam;
        }

        let expandedBills = [...this.state.expandedBills];

        for (let i = 0; i < legislationNumbers.length; i++) {
            if (!expandedBills.find(x => x.LegislationNumber === legislationNumbers[i])) {
                let bill = this.state.legislationList.find(x => x.LegislationNumber === legislationNumbers[i]);
                bill.expanded = true;
                expandedBills.push(bill);
            } else {
                expandedBills.find(x => x.LegislationNumber === legislationNumbers[i]).expanded = toggleAll !== undefined ? toggleAll : !expandedBills.find(x => x.LegislationNumber === legislationNumbers[i]).expanded;
            }
        }

        this.setState({
            expandedBills: expandedBills
        })
    }

    toggleExpandAll(crossRefList) {
        if (crossRefList) {
            let legNumbers = [];
            this.state.legislationList.forEach(x => {
                if (x.watchlists.length > 0) {
                    legNumbers.push(x.LegislationNumber)
                }
            })
            this.setState({
                expandAllBills: !this.state.expandAllBills
            }, () => {
                this.toggleWatchlistList(legNumbers, this.state.expandAllBills)
            })
        } else {
            let watchlists = [];
            this.state.watchlists.forEach(x => {
                if (x && x.WatchListLegislation.length > 0) {
                    watchlists.push(x.WatchListID);
                }
            })
            this.setState({
                expandAllWatchlists: !this.state.expandAllWatchlists
            }, () => {
                this.toggleBillList(watchlists, this.state.expandAllWatchlists)
            })
        }
    }

    handlePrint(e) { // If the header is in an actual thead, then it repeats on every page when it print. I wanted a dotted border to, but the dots were like 20px long ...
        e.preventDefault();
        const printWindow = this.printRef.current;
        if (printWindow) {
            const table = document.createElement('table');
            const headerRow = document.createElement('tr');
            const name = document.createElement('th');
            name.textContent = 'Name';
            name.style.width = '50%';
            const description = document.createElement('th');
            description.textContent = 'Description';
            description.style.width = '30%';
            const lastModified = document.createElement('th');
            lastModified.textContent = 'Last Modified';
            lastModified.style.width = '20%';
            headerRow.appendChild(name);
            headerRow.appendChild(description);
            headerRow.appendChild(lastModified);
            headerRow.style.textAlign = 'left';
            headerRow.style.fontWeight = 'boldest';
            const headerHr = document.createElement('hr');
            headerHr.style.margin = '1px 0';
            headerHr.style.borderColor = 'lightgray';
            const headerHrRow = document.createElement('tr');
            const headerHrHolder = document.createElement('td');
            headerHrHolder.colSpan = 3;
            headerHrHolder.appendChild(headerHr);
            headerHrRow.appendChild(headerHrHolder);
            headerRow.appendChild(headerHrRow);
            const body = document.createElement('tbody');
            body.appendChild(headerRow)
            const numericSession = this.props.nav.session.substring(0, 4);
            let sessionType;
            switch (this.props.nav.session.substring(4)) {
                case '1':
                    sessionType = 'Regular Session';
                    break;
                case '2':
                    sessionType = 'Special Session 1';
                    break;
                case '3':
                    sessionType = 'Special Session 2';
                    break;
                default:
                    sessionType = 'Session';
                    break;
            }
            const sessionString = `No bills on watchlist for ${numericSession} ${sessionType}.`;
            this.state.watchlists.filter(w => w.checked).forEach((watchlist, i, self) => {
                const row = document.createElement('tr');
                row.style.fontWeight = 'bold';
                row.style.verticalAlign = 'top';
                const name = document.createElement('td');
                name.textContent = watchlist.Name;
                const description = document.createElement('td');
                description.textContent = watchlist.Description;
                const lastModified = document.createElement('td');
                lastModified.textContent = watchlist.ModificationDate;
                name.style.paddingTop = '5px';
                description.style.paddingTop = '5px';
                lastModified.style.paddingTop = '5px';
                row.appendChild(name);
                row.appendChild(description);
                row.appendChild(lastModified);
                body.appendChild(row);
                const billsRow = document.createElement('tr');
                const bills = document.createElement('td');
                bills.colSpan = 3;
                bills.style.whiteSpace = 'pre-line';
                bills.textContent = watchlist.WatchListLegislation.map(l => `${l.LegislationNumber} - ${l.Description}`).join('\n');
                if (bills.textContent === '') {
                    bills.textContent = sessionString;
                }
                if (i !== self.length - 1) {
                    const hr = document.createElement('hr')
                    hr.style.margin = '1px 0';
                    hr.style.borderColor = 'lightgray';
                    bills.appendChild(hr);
                }
                billsRow.appendChild(bills);
                body.appendChild(billsRow);
            });
            table.appendChild(body);
            printWindow.contentDocument.body.innerHTML = table.outerHTML;
            printWindow.focus();
            setTimeout(() => printWindow.contentWindow.print(), 10);
        }
    }

    render() {
        let watchlists = this.state.filterValue ?
            this.state.watchlists.filter(w => (w.Description && w.Description.toLowerCase().includes(this.state.filterValue.toLowerCase())) || (w.Name && w.Name.toLowerCase().includes(this.state.filterValue.toLowerCase())))
            : this.state.watchlists;

        let bills = (this.state.filteredBillsValue.length > 0 ? this.state.filteredBills.filter(x => x != undefined) : this.state.legislationList).sort(sortLegislations);
        let sessionCode = this.props.nav.session;

        const { isProfilePage, label } = this.props;

        let heading = label ?? 'Watchlists';
        if (!isProfilePage) {
            heading = 'My ' + heading;
        }
        if (this.state.viewCrossReferenceList) {
            heading += ': Bill Cross Reference';
        }
        const header = isProfilePage ? <h3>{heading}</h3> : <h2>{heading}</h2>;

        return (
            <div>
                {this.state.showPopup &&
                    <DeleteWatchlistModal singular={this.state.watchlists.filter(w => w.checked)?.length === 1} close={this.togglePopup} delete={this.deleteWatchlists} disabled={this.state.deletingWatchlists} />
                }
                <div className="watchlists-heading">
                    {header}
                    <div>
                        {this.state.legislationList.length > 0 && (
                            !this.state.viewCrossReferenceList ?
                                <LinkAsButton className={'right'} ariaLabel={'Bill Cross Reference'} text={'Bill Cross Reference'} onClick={() => this.toggleCrossReferenceList()} show={true} />
                                :
                                <LinkAsButton className={'right'} ariaLabel={'Watchlists'} text={'Watchlists'} onClick={() => this.toggleCrossReferenceList()} show={true} />
                        )}
                    </div>
                </div>
                {!this.props.login.isAuthenticated ?
                    <div>Please login to view your watchlists.</div>
                    : this.state.loadingCollections ? <div className="spinner" /> :
                        <React.Fragment>
                            <div className={"watchlists-table " + (this.state.viewCrossReferenceList && "cross-reference-list")}>
                                {this.state.viewCrossReferenceList
                                    ?
                                    <div className="inner-grid small-one-util table-headers">
                                        <label>Bill</label>
                                        <label>Description</label>
                                        <div>
                                            <label onClick={(e) => this.toggleExpandAll(true)} style={{ cursor: 'pointer' }}>Watchlists </label>
                                            <LinkAsButton text={'+/-'} show={true} onClick={(e) => this.toggleExpandAll(true)} ariaLabel={`${!this.state.expandAllBills ? 'Expand' : 'Collapse'} Bills`} />
                                        </div>
                                    </div>
                                    : <>
                                        <div className="table-controls">
                                            <div>
                                                <button className="button danger" type="button" aria-label={'delete watchlist'} disabled={!this.state.watchlists.find(w => w.checked) || this.state.deletingWatchlists} title='Delete watchlist(s)' onClick={this.togglePopup}>
                                                    <span className="icon bin" />
                                                </button>
                                            </div>
                                            <div>
                                                <button className="button printer" type="button" aria-label={'print watchlist'} disabled={!this.state.watchlists.find(w => w.checked) || this.state.deletingWatchlists} title='Print watchlist(s)' onClick={this.handlePrint}>
                                                    <span className="icon print" />
                                                </button>
                                            </div>
                                            <div className="dlas-forms">
                                                <label htmlFor="sr-watchlist-find" className="screen-reader-only">Find a watchlist by name</label>
                                                <input
                                                    id="sr-watchlist-find"
                                                    type="text"
                                                    placeholder="Find a watchlist"
                                                    value={this.state.filterValue}
                                                    onChange={(e) => { e.preventDefault(); this.setState({ filterValue: e.target.value }) }}
                                                />
                                            </div>
                                        </div>
                                        <div className="inner-grid one-two-one table-headers">
                                            <label />
                                            <div className="sort-controls">
                                                <label onClick={() => this.sortByName()}>Name</label>
                                                <button className="sort-icon-wrapper" aria-label="sort by name" onClick={() => this.sortByName()}>
                                                    <i className={"icon up-sort " + (this.state.nameSort === false && 'active')} />
                                                    <i className={"icon down-sort " + (this.state.nameSort === true && 'active')} />
                                                </button>
                                            </div>
                                            <div className="sort-controls">
                                                <label onClick={() => this.sortByDesc()}>Description</label>
                                                <button className="sort-icon-wrapper" aria-label="sort by description" onClick={() => this.sortByDesc()}>
                                                    <i className={"icon up-sort " + (this.state.descSort === false && 'active')} />
                                                    <i className={"icon down-sort " + (this.state.descSort === true && 'active')} />
                                                </button>
                                            </div>
                                            <div className="sort-controls">
                                                <label onClick={() => this.sortByDate()} >Last Modified</label>
                                                <button className="sort-icon-wrapper" aria-label="sort by last modified" onClick={() => this.sortByDate()}>
                                                    <i className={"icon up-sort " + (this.state.dateSort === false && 'active')} />
                                                    <i className={"icon down-sort " + (this.state.dateSort === true && 'active')} />
                                                </button>
                                            </div>
                                            <div>
                                                <label style={{ cursor: "pointer" }} onClick={(e) => this.toggleExpandAll(false)}>Bills </label>
                                                <LinkAsButton text={'+/-'} show={true} onClick={(e) => this.toggleExpandAll(false)} ariaLabel={`${!this.state.expandAllWatchlists ? 'Expand' : 'Collapse'} Watchlists`} />
                                            </div>
                                        </div>
                                    </>
                                }
                                {!this.state.viewCrossReferenceList ?
                                    <div className="table-body">
                                        {watchlists.map((w, i) => {
                                            return (
                                                <div className="table-row" key={i}>
                                                    {w && <div className="inner-grid one-two-one">
                                                        <input disabled={this.state.deletingWatchlists || (w.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All")))} checked={!!w.checked} onChange={() => this.toggleWatchlist(w.WatchListID)} type="checkbox" style={{ verticalAlign: 'sub' }} />
                                                        {(w.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) ? <span className="txt-greyed">{w.Name} (PAID)</span> : <Link to={`/bill-search?collection=${w.WatchListID}`}>{w.Name}</Link>}
                                                        <label className={(w.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) ? "txt-greyed" : ""}>{w.Description}</label>
                                                        <label className={(w.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) ? "txt-greyed" : ""}>{moment(w.ModificationDate).tz('America/New_York').format("MM/DD/YYYY hh:mm A")}</label>
                                                        {(w.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) ? null : w.WatchListLegislation.length > 0 && <button style={{ marginLeft: "20px" }} type="button" aria-label={`Show/Hide ${w.Name} Bills`} className={(this.state.expandedWatchlists.find(x => x.WatchListID === w.WatchListID) == undefined || !this.state.expandedWatchlists.find(x => x.WatchListID === w.WatchListID).expanded ? "arrow-down" : "arrow-up") + " float-right"} onClick={() => this.toggleBillList(w.WatchListID)}></button>}
                                                    </div>
                                                    }
                                                    {this.state.expandedWatchlists.find(x => x.WatchListID === w.WatchListID) != undefined && this.state.expandedWatchlists.find(x => x.WatchListID === w.WatchListID).expanded &&
                                                        <ul>
                                                            {w.WatchListLegislation.map((l, i) => {
                                                                return (
                                                                    <li className="inner-grid two-col-sidebar-tiny-backwards" style={{ marginBottom: '5px' }} key={l.LegislationNumber}>
                                                                        <a target="_blank" key={i} className="watchlist-ref-link" style={{ textAlign: 'right' }} href={"/bill-details/" + sessionCode + "/" + l.LegislationNumber}>{l.LegislationNumber}</a>
                                                                        <span>{l.Description}</span>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </div>
                                    :
                                    <div className="table-body">
                                        {bills.map((l, i) => {
                                            return (
                                                <div className="table-row" key={i}>
                                                    <div className="inner-grid small-one-util" key={i}>
                                                        {<Link to={"/bill-details/" + sessionCode + "/" + l.LegislationNumber}>{l.LegislationNumber}</Link>}
                                                        <label>{renderHTML(l.Description)}</label>
                                                        {l.watchlists.length > 0 && <button style={{ marginLeft: "40px" }} type="button" aria-label={`Show/Hide ${l.LegislationNumber} Watchlists`} className={(this.state.expandedBills.find(x => x.LegislationNumber === l.LegislationNumber)?.expanded ? "arrow-up" : "arrow-down") + " float-right"} onClick={() => this.toggleWatchlistList(l.LegislationNumber)}></button>}
                                                    </div>
                                                    {this.state.expandedBills.find(x => x.LegislationNumber === l.LegislationNumber) != undefined && this.state.expandedBills.find(x => x.LegislationNumber === l.LegislationNumber).expanded &&
                                                        <ul>
                                                            {l.watchlists.map((w, i) => {
                                                                return (
                                                                    <li key={w.WatchListID}>
                                                                        <a target="_blank" key={i} className="watchlist-ref-link" href={"/bill-search?collection=" + w.WatchListID}>{w.Name}</a> - <span>{w.Description}</span>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                            </div>
                            <br />
                            {!isProfilePage && <Link to={"/bill-search"} style={{ textDecoration: 'none' }}>Return to Bill Search</Link>}
                        </React.Fragment>}
                <iframe ref={this.printRef} width="0" height="0" frameBorder="0" src="about:blank"></iframe>
            </div >
        )
    }
}

export default connect(
    (state) => {
        const { login, nav, collection, session } = state;
        return {
            login,
            nav,
            collection,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators, navActionCreators, collectionActionCreators, sessionActionCreators), dispatch)
        }
    }
)(WatchlistsComponent)
